module.exports = __webpack_public_path__ + "media/images/yardstick-logo-black-04c03840f440191e85aabacdc6116f50.svg";